export interface LocationData {
  id: string
  name: string
  city: string
  address: string
  phone: string
  email?: string
  highlights: string[]
  schedule?: DaySchedule[]
  hasSchedule: boolean
  heroImage?: string
  galleryImages?: string[]
}

export interface DaySchedule {
  day: string
  classes: ClassTime[]
}

export interface ClassTime {
  time: string
  name: string
}

export const GLOBAL_PHONE = '989-280-3402'
export const GLOBAL_EMAIL = 'Cktkd@sbcglobal.net'

export const locations: LocationData[] = [
  {
    id: 'midland',
    name: 'Midland Mall',
    city: 'Midland',
    address: '6800 Eastman Ave, Midland, Michigan',
    phone: GLOBAL_PHONE,
    email: GLOBAL_EMAIL,
    heroImage:
      'https://cdn.magicpatterns.com/uploads/nZdcA8zKcqPbmdbx6mE8dg/Midland-pic.jpg',
    galleryImages: [
      'https://cdn.magicpatterns.com/uploads/cdSQN6fkKqXD6kKvUMM9Dj/Midland-Additional-Pic.jpg',
      'https://cdn.magicpatterns.com/uploads/sRCfzERsfhFvFXRMqsktp1/Midland-Additional-Pic2.jpg',
    ],
    highlights: [
      'Flagship Location',
      'Competition Team',
      'Large Training Floor',
    ],
    hasSchedule: true,
    schedule: [
      {
        day: 'Monday',
        classes: [
          { time: '5:35–6:25 PM', name: 'Beginner Class (White–Green Stripe)' },
          {
            time: '6:30–7:30 PM',
            name: 'Advanced Class (Green Belt and Above)',
          },
        ],
      },
      {
        day: 'Tuesday',
        classes: [
          { time: '5:00–5:30 PM', name: 'Preschool Class (ages 3–5)' },
          { time: '5:35–6:25 PM', name: 'Beginner Class (Forms / Poomsae)' },
          { time: '6:00–7:00 PM', name: 'ITF Taekwondo (All Belts)' },
          { time: '6:30–7:30 PM', name: 'Advanced Class (Forms / Poomsae)' },
        ],
      },
      {
        day: 'Wednesday',
        classes: [
          { time: '5:35–6:25 PM', name: 'Traditional Class (All Belts)' },
          { time: '6:30–7:30 PM', name: 'Sparring Class (All Belts)' },
        ],
      },
      {
        day: 'Thursday',
        classes: [
          { time: '5:00–5:30 PM', name: 'Preschool Class (ages 3–5)' },
          {
            time: '5:35–6:25 PM',
            name: 'Beginner Class (Sparring / Conditioning)',
          },
          { time: '6:00–7:00 PM', name: 'ITF Taekwondo (All Belts)' },
          {
            time: '6:30–7:30 PM',
            name: 'Advanced Class (Sparring / Conditioning)',
          },
        ],
      },
      {
        day: 'Friday',
        classes: [
          { time: '5:00–5:30 PM', name: 'Preschool Class (ages 3–5)' },
          { time: '5:35–6:25 PM', name: 'Beginner Class (All Belts)' },
          { time: '6:30–8:00 PM', name: 'Competition Class' },
        ],
      },
      {
        day: 'Saturday',
        classes: [
          { time: '1:00–2:00 PM', name: 'Bo Staff Class ($5 Drop-In)' },
          { time: '2:00–3:30 PM', name: 'Competition Class' },
        ],
      },
      {
        day: 'Sunday',
        classes: [{ time: '12:00–1:30 PM', name: 'Brazilian Jiu-Jitsu' }],
      },
    ],
  },
  {
    id: 'saginaw',
    name: 'Saginaw – Fashion Square Mall',
    city: 'Saginaw',
    address: '4865 Fashion Square Mall, Suite C-327, Saginaw, Michigan 48604',
    phone: '989-280-3402',
    email: GLOBAL_EMAIL,
    heroImage:
      'https://cdn.magicpatterns.com/uploads/1wxNiqJDapFQbSAuyLYZCm/Saginaw-Main-Pic.jpg',
    galleryImages: [
      'https://cdn.magicpatterns.com/uploads/sG7iLifvMSGD3i7eAfU84k/Saginaw-Additional-Pic1.jpg',
      'https://cdn.magicpatterns.com/uploads/rdjsiJAZFzGsBcGrwyguyN/Saginaw-Additional-Pic2.jpg',
    ],
    highlights: [
      'Taekwondo',
      'Tang Soo Do',
      'Bo Staff Class',
      'Mall Convenience',
    ],
    hasSchedule: true,
    schedule: [
      {
        day: 'Monday, Wednesday, and Friday',
        classes: [
          { time: '5:35–6:25 PM', name: 'Beginner Class (ages 6 and up)' },
          { time: '6:35–7:30 PM', name: 'Advanced Class' },
        ],
      },
      {
        day: 'Tuesday and Thursday',
        classes: [
          { time: '5:30–6:00 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '6:05–6:55 PM', name: 'Beginner Class (ages 6 and up)' },
          { time: '7:05–8:00 PM', name: 'Advanced Class' },
        ],
      },
      {
        day: 'Saturday',
        classes: [
          { time: '10:00–11:00 AM', name: 'Bo Staff Class ($5 Drop-In)' },
          { time: '11:00 AM–12:00 PM', name: 'Beginner Class' },
          { time: '11:00 AM–12:00 PM', name: 'Advanced Class' },
          { time: '12:00–1:00 PM', name: 'Tang Soo Do' },
        ],
      },
    ],
  },
  {
    id: 'caro',
    name: 'Caro',
    city: 'Caro',
    address: '616 East Frank St, Caro, Michigan',
    phone: '989-280-3402',
    email: GLOBAL_EMAIL,
    heroImage:
      'https://cdn.magicpatterns.com/uploads/reHzAsPpWvBD8pfHYMuFd3/Caro-pic.jpg',
    galleryImages: [
      'https://cdn.magicpatterns.com/uploads/g5KVwujQPUkRaXAFHC5rQu/Caro-additional-pic.jpg',
    ],
    highlights: [
      'Taekwondo',
      'Brazilian Jiu-Jitsu',
      'Zumba',
      'Aerobic Kickboxing',
    ],
    hasSchedule: true,
    schedule: [
      {
        day: 'Monday',
        classes: [
          { time: '5:15–6:15 PM', name: 'Zumba' },
          { time: '6:30–7:00 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '7:00–8:00 PM', name: 'Tae Kwon Do (ages 6 and up)' },
        ],
      },
      {
        day: 'Tuesday',
        classes: [
          { time: '5:30–6:50 PM', name: 'Brazilian Jiu-Jitsu (No-Gi)' },
          { time: '7:00–8:00 PM', name: 'Tae Kwon Do (ages 6 and up)' },
          { time: '8:10–9:00 PM', name: 'Aerobic Kickboxing' },
        ],
      },
      {
        day: 'Wednesday',
        classes: [
          { time: '5:30–6:20 PM', name: 'Brazilian Jiu-Jitsu (Open Mat)' },
          { time: '6:30–7:00 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '7:00–8:00 PM', name: 'Tae Kwon Do (ages 6 and up)' },
        ],
      },
      {
        day: 'Thursday',
        classes: [
          { time: '5:30–6:50 PM', name: 'Brazilian Jiu-Jitsu (Gi)' },
          { time: '7:00–8:00 PM', name: 'Tae Kwon Do (ages 6 and up)' },
          { time: '8:10–9:00 PM', name: 'Aerobic Kickboxing' },
        ],
      },
      {
        day: 'Saturday',
        classes: [
          { time: '11:00 AM–12:00 PM', name: 'Brazilian Jiu-Jitsu (Open Mat)' },
          { time: '5:00–6:00 PM', name: 'Competition Class' },
        ],
      },
    ],
  },
  {
    id: 'bridgeport',
    name: 'Bridgeport',
    city: 'Bridgeport',
    address: '5126 Dixie Hwy, Saginaw, Michigan 48601',
    phone: '989-280-3402',
    email: GLOBAL_EMAIL,
    heroImage:
      'https://cdn.magicpatterns.com/uploads/gdEDGuyQ4ETTS62fapuGnx/Bridgeport-Main-Pic.jpg',
    galleryImages: [
      'https://cdn.magicpatterns.com/uploads/6PZKFc2FvasM1T22weYSP4/Bridgeport-Additional-Pic.jpg',
      'https://cdn.magicpatterns.com/uploads/bauUCcN5QPBreDQAo3DmaG/Bridgeport-Additional-Pic2.jpg',
    ],
    highlights: [
      'Taekwondo',
      'Tang Soo Do',
      'Traditional Training',
      'Community Focused',
    ],
    hasSchedule: true,
    schedule: [
      {
        day: 'Monday',
        classes: [
          { time: '4:20–4:50 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '5:00–5:50 PM', name: 'Novice Classes (ages 6 and up)' },
          { time: '6:00–6:55 PM', name: 'Advance Classes (ages 6 and up)' },
          { time: '7:00–7:55 PM', name: 'Tang Soo Do' },
          { time: '7:00–8:00 PM', name: 'MMA Classes' },
        ],
      },
      {
        day: 'Tuesday',
        classes: [{ time: '7:00–8:00 PM', name: 'MMA Classes' }],
      },
      {
        day: 'Wednesday',
        classes: [
          { time: '4:20–4:50 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '5:00–5:50 PM', name: 'Novice Classes (ages 6 and up)' },
          { time: '6:00–6:55 PM', name: 'Advance Classes (ages 6 and up)' },
          { time: '7:00–7:55 PM', name: 'Tang Soo Do' },
          { time: '8:00–9:00 PM', name: 'MMA Classes' },
        ],
      },
      {
        day: 'Thursday',
        classes: [{ time: '7:00–8:00 PM', name: 'MMA Classes' }],
      },
      {
        day: 'Friday',
        classes: [
          { time: '5:00–5:55 PM', name: 'Novice Classes (ages 6 and up)' },
          { time: '6:00–6:55 PM', name: 'Advance Classes (ages 6 and up)' },
          { time: '7:00–7:55 PM', name: 'Tang Soo Do' },
        ],
      },
    ],
  },
  {
    id: 'hemlock',
    name: 'Hemlock',
    city: 'Hemlock',
    address: '14980 Gratiot Rd, Hemlock, Michigan',
    phone: GLOBAL_PHONE,
    email: GLOBAL_EMAIL,
    heroImage:
      'https://cdn.magicpatterns.com/uploads/ntiRNM1UNhcDLdMBtGYMdx/Hemlock.jpg',
    galleryImages: [
      'https://cdn.magicpatterns.com/uploads/ntiRNM1UNhcDLdMBtGYMdx/Hemlock.jpg',
    ],
    highlights: [
      'Beginner Friendly',
      'Small Class Sizes',
      'Personal Attention',
    ],
    hasSchedule: true,
    schedule: [
      {
        day: 'Tuesday and Thursday',
        classes: [
          { time: '4:00–4:30 PM', name: 'Preschool Class (ages 3–5)' },
          { time: '4:40–5:40 PM', name: 'Beginner Class (ages 6 and up)' },
        ],
      },
    ],
  },
  {
    id: 'bay-city',
    name: 'Bay City',
    city: 'Bay City',
    address: '916 Washington Ave, Suite 100, Bay City, Michigan',
    phone: GLOBAL_PHONE,
    heroImage:
      'https://cdn.magicpatterns.com/uploads/q4ehcpRxhL1uStiBYSbxDC/Bay_City-Main.jpg',
    galleryImages: [
      'https://cdn.magicpatterns.com/uploads/gzKH5u7HCAPf2m9VjFXdmd/Bay_City-Additional.jpg',
    ],
    highlights: [
      'Modern Training Facility',
      'Youth Programs',
      'Free Trial Classes',
    ],
    hasSchedule: true,
    schedule: [
      {
        day: 'Tuesday',
        classes: [
          { time: '4:30–5:00 PM', name: 'Mini Kickers (ages 3–6)' },
          { time: '5:05–6:00 PM', name: 'Fundamentals (ages 7 and up)' },
        ],
      },
      {
        day: 'Thursday',
        classes: [
          { time: '4:30–5:00 PM', name: 'Mini Kickers (ages 3–6)' },
          { time: '5:05–6:00 PM', name: 'Fundamentals (ages 7 and up)' },
        ],
      },
    ],
  },
]

export function getLocationById(id: string): LocationData | undefined {
  return locations.find((loc) => loc.id === id)
}
